import {
  IAppConfig,
  IUser,
  IUsers,
  IUsersBulkDelete,
  IUsersBulkUpload,
} from '../types';
import {
  handleJsonResponse,
  handleNoContentResponse,
  handleTextResponse,
} from './fetchHelpers';

import URI from 'urijs';

export function getCanaryUsersRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  params: Record<string, string | number>,
): Promise<IUsers> {
  return handleJsonResponse(
    fetch(
      URI(treatCanaryApiUrl)
        .segment('canaryusers')
        .query({
          gwRegion: gwRegion,
          page: params.page,
          size: params.size,
          sort: params.sort,
          userLogin: params.userLogin || '',
          displayName: params.displayName || '',
        })
        .toString(),
      {
        method: 'GET',
      },
    ),
  );
}

export function addCanaryUserRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  userPrincipalName: string | undefined,
): Promise<IUser> {
  return handleJsonResponse(
    fetch(`${treatCanaryApiUrl}/canaryusers?gwRegion=${gwRegion}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userPrincipalName: userPrincipalName }),
    }),
  );
}

export function deleteCanaryUserRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  userLogin: string | undefined,
): Promise<void> {
  return handleNoContentResponse(
    fetch(
      `${treatCanaryApiUrl}/canaryusers/${userLogin}?gwRegion=${gwRegion}`,
      {
        method: 'DELETE',
      },
    ),
  );
}

export function deleteAllCanaryUsersRequest({
  treatCanaryApiUrl,
  gwRegion,
}: IAppConfig) {
  return handleTextResponse(
    fetch(`${treatCanaryApiUrl}/canaryusers?gwRegion=${gwRegion}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    }),
  );
}

export function bulkUploadCanaryUsersRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  file?: File | null,
): Promise<IUsersBulkUpload> {
  return handleJsonResponse(
    fetch(`${treatCanaryApiUrl}/canaryusers/batch?gwRegion=${gwRegion}`, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: file,
    }),
  );
}

export function bulkDeleteCanaryUsersRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  file?: File | null,
): Promise<IUsersBulkDelete> {
  return handleJsonResponse(
    fetch(`${treatCanaryApiUrl}/canaryusers/batch?gwRegion=${gwRegion}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'text/plain' },
      body: file,
    }),
  );
}
